// Presentation mapping for live blog posts (@astro/api blog → insight cards).
// The old hardcoded INSIGHTS array is gone — the section fetches from
// GET /v1/blog-posts and decorates each record here.

const stripHtml = (html) =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&mdash;/g, '—')
    .replace(/&rsquo;|&#39;/g, "'")
    .replace(/&quot;|&ldquo;|&rdquo;/g, '"')
    .replace(/\s+/g, ' ')
    .trim()

const formatDate = (iso) => {
  if (!iso) return ''
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

/** ~200 wpm reading speed on the plain-text body. */
const readTime = (text) => {
  const words = text.split(' ').filter(Boolean).length
  return `${Math.max(1, Math.round(words / 200))} min read`
}

const excerptFrom = (post, plainContent) => {
  const own = (post.excerpt ?? '').trim()
  if (own) return own
  if (plainContent.length <= 140) return plainContent
  const cut = plainContent.slice(0, 140)
  return `${cut.slice(0, cut.lastIndexOf(' '))}…`
}

/** Shape a live API blog post into the props InsightCard renders. */
export function decorateInsight(post, index) {
  const plain = stripHtml(post.content)
  return {
    id: post.id,
    slug: post.slug,
    img: post.featured_image_url,
    alt: post.title,
    badge: post.category?.name ?? 'Insights',
    title: post.title,
    excerpt: excerptFrom(post, plain),
    date: formatDate(post.published_at),
    readTime: readTime(plain),
    delay: `${(0.16 + index * 0.06).toFixed(2)}s`,
  }
}
